// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var container = "BetPickAutomation-module--container--42888";
export var content = "BetPickAutomation-module--content--1ecfd";
export var dashedLine = "BetPickAutomation-module--dashedLine--b7563";
export var dull = "BetPickAutomation-module--dull--d7d20";
export var dullText = "BetPickAutomation-module--dullText--eaab5";
export var emphasis = "BetPickAutomation-module--emphasis--f0737";
export var green = "#57d33b";
export var greenLink = "BetPickAutomation-module--green-link--a24e8";
export var grey = "var(--tone-mid)";
export var hollow = "BetPickAutomation-module--hollow--32e94";
export var inProgress = "BetPickAutomation-module--inProgress--d5a6f";
export var link = "BetPickAutomation-module--link--a97da";
export var notPaid = "BetPickAutomation-module--notPaid--ce4fc";
export var notchGap = "32px";
export var orange = "#f8662b";
export var paid = "BetPickAutomation-module--paid--1bb62";
export var payout = "BetPickAutomation-module--payout--30d3b";
export var perkIcon = "BetPickAutomation-module--perkIcon--04297";
export var promoIcon = "BetPickAutomation-module--promoIcon--a0f88";
export var red = "#ff2741";
export var soft = "BetPickAutomation-module--soft--e0f1d";
export var statusClamp = "BetPickAutomation-module--statusClamp--a5fc6";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";